import React from "react";

import ContactUs from "./ContactUs";

import "./Mern.css";
import syllabusPDF from "../assets/MERNSyllabus.pdf";

const Mern = () => {


  return (
    <>
      {/* ✅ Top Navigation */}
      

      {/* ✅ Main MERN Course Section */}
      <section className="mern-section">
        <div className="mern-container">
          <h1 className="mern-title">MERN Stack Training Course</h1>
          <p className="mern-subtitle">FullStack Website Development</p>

          <div className="mern-rating">
            <span>⭐ 4.8 Reviews</span>
          </div>

          <div className="mern-duration">
            <p><strong>Duration:</strong> 3 to 4 Months</p>
            <p><strong>15+ Guaranteed Interviews</strong></p>
          </div>

          <div className="mern-description">
            <p>
              Are you passionate about web development? Dive into the dynamic world of programming
              with our comprehensive MERN Stack course. MERN, an acronym for
              <strong> MongoDB</strong>, <strong>Express.js</strong>, <strong>React.js</strong>,
              and <strong>Node.js</strong>, is a powerful combination of technologies that enables
              you to build robust, full-stack web applications.
            </p>
            <button
              className="mern-btn"
              onClick={() => window.open(syllabusPDF, "_blank")}
            >
              📘 Download Syllabus
            </button>
          </div>

          <h2 className="mern-heading">Boost Your Career with MERN Stack Course in Indore</h2>
          <p className="mern-text">
            In our MERN Stack course, you'll embark on a journey from beginner to proficient developer.
            Whether you're a student exploring the realms of coding or a seasoned professional seeking
            to expand your skill set, this course caters to all levels of expertise.
          </p>

          <h2 className="mern-heading">What You Will Learn?</h2>
          <p className="mern-text">
            Our instructors, seasoned industry professionals, provide personalized guidance and support,
            ensuring that you grasp the core concepts effectively. Moreover, our curriculum is constantly
            updated to align with the latest industry trends and best practices.
          </p>

          <ul className="mern-list">
            <li>
              <strong>Fundamentals of MERN Stack:</strong> Understand the core components of the MERN
              (MongoDB, Express.js, React.js, Node.js) stack, gaining proficiency in each technology
              and their interactions.
            </li>
            <li>
              <strong>Building RESTful APIs:</strong> Learn to design and implement robust RESTful APIs
              using Node.js and Express.js, enabling seamless communication between client and server.
            </li>
            <li>
              <strong>Frontend Development with React.js:</strong> Master the concepts of component-based
              UI development using React.js, including state management, routing, and integration with
              backend services.
            </li>
            <li>
              <strong>Database Management with MongoDB:</strong> Explore MongoDB, a NoSQL database, to store
              and manage data efficiently within MERN applications, covering CRUD operations and schema design.
            </li>
            <li>
              <strong>Deployment and DevOps:</strong> Gain insights into deploying MERN applications to
              production environments, utilizing best practices in configuration, monitoring, and scaling,
              while also learning version control with Git.
            </li>
          </ul>

          <h2 className="mern-heading">Why choose Codex Future for MERN Stack Training?</h2>
          <p className="mern-text">
            Looking to break into the exciting world of web development? Then the MERN stack is your key!
            But where do you learn the in-demand skills to build dynamic web applications? Look no further
            than <strong>Codex Future Indore!</strong>
          </p>

          <p className="mern-text">
            We offer a comprehensive MERN stack course designed for students of all levels.
          </p>
        </div>
      </section>

      {/* ✅ Bottom Contact Section */}
      <ContactUs />

     
    </>
  );
};

export default Mern;
